import type { MigrationJob } from '@mailserver/web-shared/api';

/**
 * A migration's steps, as URL segments (context STORY-0270): `/migrations/$migrationId/$step`, in the
 * order the work is done. Out of `migration.tsx` so the router can check one without its chunk.
 */
export const MIGRATION_STEPS = ['source', 'discover', 'map', 'copy', 'cutover'] as const;
export type MigrationStep = (typeof MIGRATION_STEPS)[number];
export const isMigrationStep = (s: string): s is MigrationStep =>
  (MIGRATION_STEPS as readonly string[]).includes(s);

/**
 * Where a job is: the step to open when its page is opened without one. No credentials → Source (they
 * must be entered again); nothing to copy yet → Discover, or Map for plain IMAP, which cannot discover;
 * not started → Map; started → Copy; finished → Cut over.
 */
export function currentStep(
  j: Pick<MigrationJob, 'state' | 'hasSecret' | 'kind' | 'mailboxCount' | 'startedAt'>,
): MigrationStep {
  if (j.state === 'done' || j.state === 'cancelled') return 'cutover';
  if (!j.hasSecret) return 'source';
  if (j.state === 'running' || j.state === 'paused' || j.state === 'failed' || j.startedAt) return 'copy';
  if (j.mailboxCount === 0) return j.kind === 'imap' ? 'map' : 'discover';
  return 'map';
}
